const actions = {
  newMessage: () => {
    /**
     * Empty action. This help extend websocket behaviours in vuex
     * subscriber.
     */
  },
}

export default {
  namespaced: true,
  actions,
}
